import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestApiKeyScopes() {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/user/me/api-keys/scopes`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestMyApiKeys() {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/user/me/api-keys`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateApiKey(data) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/user/me/api-keys`,
        withCredentials: true,
        crossorigin: true,
        data,
    });
}

export function requestRevokeMyApiKey(keyId) {
    return axios.request({
        method: 'delete',
        url: `${getApiUrl()}/user/me/api-keys/${keyId}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAllApiKeys(params) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/user/api-keys`,
        withCredentials: true,
        crossorigin: true,
        params,
    });
}

export function requestUserApiKeys(userId) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/user/${userId}/api-keys`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRevokeUserApiKey(userId, keyId) {
    return axios.request({
        method: 'delete',
        url: `${getApiUrl()}/user/${userId}/api-keys/${keyId}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteUserApiKey(userId, keyId) {
    return axios.request({
        method: 'delete',
        url: `${getApiUrl()}/user/${userId}/api-keys/${keyId}/permanent`,
        withCredentials: true,
        crossorigin: true,
    });
}
